import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-153dcbc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-xl min-vh-100 section-container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col pt-3 pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverheaderComponent = _resolveComponent("OverheaderComponent")!
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_SidebarComponent = _resolveComponent("SidebarComponent")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MobileNavComp = _resolveComponent("MobileNavComp")!
  const _component_ScrollTopButtonComponent = _resolveComponent("ScrollTopButtonComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverheaderComponent),
    _createVNode(_component_HeaderComponent),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_component_SidebarComponent),
        _createElementVNode("main", _hoisted_3, [
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _createVNode(_component_MobileNavComp),
    _createVNode(_component_ScrollTopButtonComponent),
    _createVNode(_component_FooterComponent)
  ], 64))
}